import { useState } from 'react';
import Timer from 'components/calls/molecules/timer';
import {
  Divider,
  HeaderLogo,
  MobileLogo,
  RecordingContainer,
  ReportButtonContainer,
  RightSide,
  ScreenRecord,
  Wrapper,
} from './styles';
import ReportFlagIcon from 'components/calls/atoms/Icon/ReportFlagIcon';
import ReportIssueModal from '../modals/report-issue-modal';
import useIsMobile from 'utils/useIsMobile';

const Header = ({
  showRecording,
  maxLengthInSeconds,
  recordingStartEpoch,
  roomId,
  userId,
}: {
  showRecording?: boolean;
  maxLengthInSeconds?: string;
  recordingStartEpoch?: number;
  roomId?: string;
  userId?: string;
}) => {
  const [showReportIssueModal, setShowReportIssueModal] = useState(false);
  const isMobile = useIsMobile();

  return (
    <Wrapper>
      <ReportIssueModal
        isOpen={showReportIssueModal}
        close={() => setShowReportIssueModal(false)}
        roomId={roomId}
        userId={userId}
      />
      {!isMobile ? (
        <HeaderLogo />
      ) : (
        <MobileLogo>
          <h1>Mbg</h1>
        </MobileLogo>
      )}
      <RightSide>
        {showRecording && (
          <>
            <RecordingContainer>
              <ScreenRecord />
              <Timer maxLengthInSeconds={maxLengthInSeconds || ''} startEpochMs={recordingStartEpoch} />
            </RecordingContainer>
            <Divider />
          </>
        )}
        <ReportButtonContainer onClick={() => setShowReportIssueModal(true)}>
          <ReportFlagIcon />
          <p>Report an issue</p>
        </ReportButtonContainer>
      </RightSide>
    </Wrapper>
  );
};

export default Header;
